import { Col, Row, message } from 'antd'
import { Container } from 'react-bootstrap'

import { SyncOutlined } from '@ant-design/icons'
import StyledTooltip from 'components/Elements/StyledTooltip'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BsPersonCheckFill } from 'react-icons/bs'
import { MdContactMail } from 'react-icons/md'
import { useParams } from 'react-router-dom'
import axiosClient from 'services/axios-client'
import { ROLE_TYPES_REVERSE } from 'services/constants'
import { useBookRoleQuery } from 'store/queries'
import { FriendRowContainer } from './style'

const roles = {
  en: {
    Purchaser: 'Purchaser',
    Editor: 'Editor',
    Author: 'Author',
    Reader: 'Reader',
    Guest: 'Guest',
  },
  de: {
    Purchaser: 'Erwerber/-in',
    Editor: 'Editor/-in',
    Author: 'Autor/-in',
    Reader: 'Leser/-in',
    Guest: 'Gast',
  },
}

const tooltips = {
  Editor:
    'Editors will be able to add other users and control aspects of the book.',
  Author:
    'Authors will be able to write responses to prompts and add readers to them.',
  Reader: 'Readers will be able to read submitted stories.',
  Guest: 'Guests may have access added for individual stories.',
}

const FriendRow = ({ friend = {}, index, onEditRow }) => {
  const { bookId } = useParams()
  const { t } = useTranslation()
  const { lang } = useContext(DataContext)

  const [isResending, setIsResending] = useState(false)

  const { data: role } = useBookRoleQuery(bookId)
  const myRole = role?.name

  // TODO: Rename name to role.
  const isEditorAndCanEdit =
    myRole === 'Editor' &&
    friend.name !== 'Purchaser' &&
    friend.name !== 'Editor'

  const canEditRole =
    (myRole === 'Purchaser' && friend.name !== 'Purchaser') ||
    isEditorAndCanEdit

  const onClickEmailResend = async (e, friend) => {
    e.stopPropagation()

    setIsResending(true)
    let postData = {
      first: friend.first_name,
      last: friend.last_name,
      email: friend.email,
      book_id: parseInt(bookId),
      link: 'BOOK',
      role: ROLE_TYPES_REVERSE[`${friend.role_type_id}`],
      invite_type: 'resend',
    }
    const inviteResult = await axiosClient.post(
      `/book/${bookId}/sendInvite`,
      postData,
    )
    if (inviteResult.ok) {
      message.success(t('invite_resend'))
    } else {
      message.error(t('something_went_wrong'))
    }
    setIsResending(false)
  }

  return (
    <FriendRowContainer
      className={`${index % 2 === 0 ? 'bg-white' : 'bg-white'}`}
      data-testid="friends-row"
    >
      <Container fluid className="px-3">
        <Row align="middle">
          <Col md={6} xs={12}>
            <div className="friend-col">
              <h6 className="friend-name">
                {`${friend?.first_name} ${friend?.last_name}`}
              </h6>
            </div>
          </Col>
          <Col md={2} xs={0}>
            <div className="friend-col">
              {(role?.name === 'Purchaser' ||
                role?.name === 'Editor' ||
                role?.name === 'Author') &&
                (!friend['cognito_id'] ||
                  typeof friend['cognito_id'] === 'boolean') && (
                  <div
                    className="icon-invite"
                    onClick={(e) => onClickEmailResend(e, friend)}
                  >
                    {isResending ? (
                      <SyncOutlined spin />
                    ) : (
                      <StyledTooltip
                        title={t('tt_resend_invite')}
                        placement="top"
                      >
                        <MdContactMail
                          size={30}
                          className="cursor icon-option"
                        />
                      </StyledTooltip>
                    )}
                  </div>
                )}
            </div>
          </Col>
          <Col md={9} xs={0}>
            <div className="friend-col">
              <h6 className="friend-email">{friend?.email}</h6>
            </div>
          </Col>
          {canEditRole ? (
            <Col md={6} xs={12}>
              <div
                className="friend-col friend-role"
                onClick={() => onEditRow(friend, index)}
              >
                <StyledTooltip title={tooltips[friend.name]} placement="top">
                  <div className="role-cell">
                    <div>
                      <BsPersonCheckFill
                        size={26}
                        className="cursor icon-option role-icon"
                      />
                    </div>

                    <h6 className="role-name cursor">
                      {roles[lang][friend.name]}
                    </h6>
                  </div>
                </StyledTooltip>
              </div>
            </Col>
          ) : (
            <Col md={6} xs={12}>
              <div className="friend-col friend-role role-uneditable">
                {roles['en'][friend.name] === 'Purchaser' ? (
                  <span>{roles[lang][friend.name]}</span>
                ) : (
                  <h6>{roles[lang][friend.name]}</h6>
                )}
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </FriendRowContainer>
  )
}

export default FriendRow
